module.exports = __webpack_public_path__ + "img/elevator2.a0b7fd8d.png";